import React from "react";
import { Stack } from "@mui/system";

import { AdditionalImageSeriesWidgetData } from "@/types/additional-widget-data";
import { Image } from "@/types/serie";
import { ImageSelector } from "@/features/shared/widgets/components";
import { default as ImageComponent } from "@/features/shared/components/image/image";
import useRefetchWidget from "@/features/shared/widgets/hooks/useRefetchWidget";

type Props = {
  id: string;
  data: AdditionalImageSeriesWidgetData;
};

const Radar = ({ id, data }: Props) => {
  useRefetchWidget(id);

  const [selectedImageIndex, setSelectedImageIndex] = React.useState(0);

  const { data: series } = data;

  const images = React.useMemo(
    () =>
      series
        .map((serie) => serie.image)
        .filter((image): image is Image => image !== undefined),
    [series],
  );

  const selectedImage = React.useMemo(
    () => images?.[selectedImageIndex],
    [images, selectedImageIndex],
  );

  return (
    <Stack gap={1.5} direction="column" height="100%">
      <ImageSelector
        images={images}
        selectedImageIndex={selectedImageIndex}
        onSelectedImageChange={setSelectedImageIndex}
      />

      {selectedImage && (
        <div
          style={{
            maxHeight: "calc(100% - 68px)",
          }}
        >
          <ImageComponent
            {...selectedImage}
            src={selectedImage.url}
            caption={selectedImage.name}
          />
        </div>
      )}
    </Stack>
  );
};

export default Radar;
